/**
 * Sendungsverfolgung — erkennt den Versanddienstleister anhand des
 * Trackingnummern-Formats und liefert die passende Verfolgungs-URL.
 *
 * Keine API-Anbindung nötig — öffnet einfach die offizielle Website
 * des Versenders mit vorausgefüllter Nummer.
 */

export function detectCarrier(trackingNumber) {
  if (!trackingNumber) return null;
  const num = trackingNumber.toString().trim().toUpperCase();

  // UPS: startet mit "1Z"
  if (/^1Z[A-Z0-9]{16}$/.test(num)) return 'ups';

  // Hermes: startet mit "H" oder ist 14-stellig alphanumerisch
  if (num.startsWith('H') && num.length >= 12) return 'hermes';

  // DPD: 14 Stellen, nur Ziffern
  if (/^\d{14}$/.test(num)) return 'dpd';

  // DHL: viele Formate:
  //   - 20-stellig, oft "003400..." beginnend
  //   - 12- bis 22-stellig, nur Ziffern
  //   - Internationale Sendungen: JD... oder RR...
  if (/^\d{12,22}$/.test(num) || /^JD\d+/.test(num) || /^RR\d+/.test(num)) return 'dhl';

  return 'unknown';
}

export function buildTrackingUrl(trackingNumber) {
  const carrier = detectCarrier(trackingNumber);
  const num = encodeURIComponent(trackingNumber.trim());

  switch (carrier) {
    case 'dhl':
      return {
        url: `https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode=${num}`,
        carrier: 'DHL',
        icon: '📦',
      };
    case 'dpd':
      return {
        url: `https://tracking.dpd.de/status/de_DE/parcel/${num}`,
        carrier: 'DPD',
        icon: '📦',
      };
    case 'hermes':
      return {
        url: `https://www.myhermes.de/empfangen/sendungsverfolgung/detail#${num}`,
        carrier: 'Hermes',
        icon: '📦',
      };
    case 'ups':
      return {
        url: `https://www.ups.com/track?loc=de_DE&tracknum=${num}`,
        carrier: 'UPS',
        icon: '📦',
      };
    default:
      // Fallback: Universal-Tracker (kostenloser Dienst, keine Anmeldung)
      return {
        url: `https://parcelsapp.com/de/tracking/${num}`,
        carrier: 'Paket-Tracker',
        icon: '📦',
      };
  }
}
